import React from 'react';
import ProjectsContext from './ProjectsContext';
import styled from 'styled-components';
// import ActionsFunctionSelection from './ActionsFunctionSelection';
import {Select,MenuItem,FormControl,InputLabel,makeStyles,FormHelperText,Divider} from '@material-ui/core';
import ProjectSearch from './ProjectSearch';
const ProjectContainer = styled.div`
    display:flex;
    align-items:center;
    justify-content:space-between;
    width:100%;
    // padding-left:30px;
    // padding-right:30px;
    // min-height:75px;
`

const Container = styled.div`
width:100%;
background-color:white;

`
const ProjectName = styled.div`
font-family: Roboto;
font-size: 24px;
font-weight: 500;
`
const ProjectSelect = styled.div`
`
const SelectContainer = styled.div`
    width:240px;
`;


const FunctionsContainer = styled.div`
    padding-left:20px;
    padding-right:20px;
    padding-bottom:4px;

`;

const SearchContainer = styled.div`
    // padding-left:20px;
    // width:400px;
    width: 240px;
`;

const ProjectSearchContainer = styled.div `
    display:flex;
`


const useStyles = makeStyles((theme) => ({
    formControl: {
      margin: theme.spacing(1),
      minWidth: 220,
    },
    selectEmpty: {
      marginTop: theme.spacing(2),
    },
  }));

const ProjectSelection = ( ) => {

    const context = React.useContext(ProjectsContext);

    // const projects = context.actionsRedux.projectFunctions;
    // const projects = context.projects;
    const projects = [];
    if (context.projects && context.projects.gbus && context.projects.gbus.forEach) {
        context.projects.gbus.forEach(function (gbu, index) {
            gbu.projects.forEach(function (project, i) {
                projects.push(project);
            });
        });
    }
    else if (context.reduxStore && context.reduxStore.gbus) {
        let gbus = []; 
        for(let key in context.reduxStore.gbus){  
            if(context.reduxStore.gbus.hasOwnProperty(key)){  
                gbus.push(context.reduxStore.gbus[key]);  
            }  
        }  

        if (gbus && gbus.length > 0) {
            for (let gbu of gbus) {
                for (let project of gbu.projects) {
                    projects.push(project);
                };
            };
        }
      
    }
    
    
  
    const classes = useStyles();

    return (
        <Container>
            <ProjectContainer>
            <ProjectName>
                {/* {context.actionsRedux.selectedProject ? context.actionsRedux.selectedProject.name : ''} */}
                {context.reduxStore.selectedProjectOrGbu ? context.reduxStore.selectedProjectOrGbu.name : ''}
            </ProjectName>
            <ProjectSelect>
            {projects.length > 1 &&
            <FormControl className={classes.formControl}>
               < ProjectSearchContainer>
                    <SearchContainer>
                        <ProjectSearch/>
                    </SearchContainer>
                </ProjectSearchContainer>

            </FormControl>
            }
            </ProjectSelect>
            </ProjectContainer>
            {/* {context.actionsRedux.selectedProject && context.actionsRedux.selectedProject.functions.length > 1 &&
            <FunctionsContainer>
                <ActionsFunctionSelection/>
            </FunctionsContainer>
            } */}
            <Divider/>
        </Container>
    );
   

}

export default ProjectSelection;